/*
* Currently a mixin to the canvas view (access channel from there).
* TODO:
* - the draw move fns should be the same as the resize fns -- start should create the basic shape .. in prog
* - get rid of IIFE singleton W/exports
* - re-org to store on shape view deriving from the base itself (now that have the ability)
* */

var $ = require('jquery'),
    _ = require('underscore'),
    Raphael = require('raphael'),// really want the extension here
    DummyRectBorder = require('./shape/helper/dummyRectBorder'),
    PolygonDrawHelper = require('./shape/redaction/polygonDrawHelper'),
    Mousetrap = require('mousetrap'),
    LockAngleCalcPosition = require('draw-lock-angle').calculatePosition,
    fvChannel = require('glRadio').channel('FV'),
    TextAreaShape = require('./shape/graphic/text/textAreaShape/textAreaShape'),
    HoverShapeFactory = require('./shape/hoverShape/hoverShapeFactory');

var ARROW_MIN = 10; // TODO: share with 'resize fns'


module.exports = new function() {

    function init() {

        _.extend( this, {
            'rect-fill': this.rect,
            'rect-nofill': this.rect,
            line: this.line,
            'line-dashed': this.line,
            'line-arrow': this.line,
            text: this.text,
            signature: this.hoverShape,
            graphic_stamp: this.hoverShape,
            text_stamp: this.hoverShape
        });
    }

    this.rect = {

        drawStart: function(e) {

            if (!this.baseDraw.start.call(this, e))
                return;

            var mm = this.mouseModel,    /* NOW NOT CONVERTING FROM RECT -- START AS PATH */
                RECT_START_LEN = 10; //*C  //NOTE IF THIS IS TOO SMALL WILL RESULT IN  Illegal input string in Vector2D (IE8) R.BUG -- ON MOVE -- 10 SEEMS TO WORK

            this.shape = this.paper.path
                ( Raphael.fn.rectPath( mm.get('xy').x, mm.get('xy').y, RECT_START_LEN, RECT_START_LEN) ).hide();    //can't use 0 for parse path to work

            this.shape.transform('');

            this.baseDraw.setShapeAttrs.call(this, this.shape);
            this.osw = this.shape.attr('stroke-width');
            this.dummyRectBorder = new DummyRectBorder(this.shape).hide();

            this.$el
                .off('mousedown', this.drawStart)
                .on('mouseup', this.drawStop)
                .on('mousemove', this.drawMove); // TODO: common fn

        },
        drawMove: function(e, dx, dy, x, y) {

            if (!this.baseDraw.move.call(this, e, x, y))
                return;

            var pos = this.getMousePos(e);

            this.shape
                .show()
                .setBoxTransformStr(pos.x, pos.y, true, true, true); //assuming south east // show

            this.dummyRectBorder
                .move()
                .show();

        },
        drawStop: function(e) {
            this.baseDraw.end.call(this, e);
            this.$el
                .off('mouseup', this.drawStop)
                .off('mousemove', this.drawMove)
                .on('mousedown', this.drawStart); //must come b/f add

            if ( this.mouseModel.isTooShortOrSmall() ) {
                this.shape.remove();
            } else {
                /* Successful: get the path of the bbox if drawing w/path b/c it may not be in 'rect' order
                      -- need to bake transform pts in 'order' for rect */
                this.shape.attr({
                    path: this.shape.getPathOfBBox(),
                    transform: ''
                });

                this.shape.attr('stroke-width', this.osw);
                this.channel.command('addNewlyDrawnShape', this.shape);
            }
            this.dummyRectBorder.destroy();
            this.osw = null; //TODO: only vml ... rid now ?
        }
    };

    this.poly = { //polygon redaction
        drawStart: function(e) {

            //called on every node (pt) created) -- mouseup
            if (!this.baseDraw.start.call(this, e))
                return;

            var mm = this.mouseModel;
            Mousetrap.bind('escape', this.drawStop);

            if (!this.polyHelper) { //first time in: create first node

                this.polyHelper = new PolygonDrawHelper();
                this.polyHelper.createFirstNode( this, mm.get('xy') );

                this.shape = this.paper.path(this.polyHelper.currentPathString);
                this.baseDraw.setShapeAttrs.call(this, this.shape);

                this.$el.on('mousemove', this.drawMove);

                this.listenToOnce(this, 'firstnode.clicked', this.drawStop);

            } else {
                //create additional nodes -- must be on mouseup
                if (this.polyHelper.nodes.length < 1) return false;
                this.polyHelper.createAdditionalNode(this, mm.get('xy'), e);
                this.shape.attr('path', this.polyHelper.currentPathString);
            }
        },
        drawMove: function(e, dx, dy, x, y) {   //draws a temp path -- line to where the mouse currently is
            if (!this.baseDraw.move.call(this, e, x, y))
                return;

            var ph = this.polyHelper;
            if (ph.nodes.length < 1) return; //exit if there are no nodes
            ph.createPolyTempPath(this.paper, this.mouseModel.get('xy') );
        },
        drawStop: function(e) { //called when last node clicked
            this.baseDraw.end.call(this, e); //need to turn off events (set isDrawing to false)
            var atLeast3SidesDrawn =  this.polyHelper.nodes.length > 2; //must be a least 3 sides -- coming from first node clicked
            if (e.type !== 'keydown' && atLeast3SidesDrawn) {
                this.shape.attr('path', this.polyHelper.getFinalPath() );
                this.channel.command('addNewlyDrawnShape', this.shape );
            } else {
                this.shape.remove();
            }
            //cleanup regardless
            this.stopListening(this, 'firstnode.clicked', this.drawStop); //NEED IF USER CANCELS WITH ESCAPE (EVEN THOUGH IS LISTENTOONCE)
            this.$el.off('mousemove', this.drawMove).off('mouseup', this.drawStart);
            Mousetrap.unbind('escape'); //it only wants the keyboard event !
            this.polyHelper.destroy();
            this.polyHelper = null; //(need obj ref)
        }
    };

    this.line = {

        drawStart: function(e) {

            if ( !this.baseDraw.start.call( this, e) )
                return;

            var mm = this.mouseModel,
                x =  mm.get('xy').x,
                y = mm.get('xy').y;

            this.lineStart = 'M' + x + ' ' + y;

            /*
            * Cache the boundary parmater required for the Lock Angle lib.
            * It wants container relative
            * TODO: -- we don't want to apply the boundary on the main fn call if using this ... ( but that's not working)
            * */
            this.lockAngleBoundary = {
                minX: this.containerRel.x,
                minY: this.containerRel.y,
                maxX: this.containerRel.x2,
                maxY: this.containerRel.y2
            };

            // TODO: should know the activeNoteSubType; don't retrieve --
            // later address with subclassing
            var lCh = this.channel,
                arrowAttr = lCh.request('activeNote').defaultSVGAttrsEdit(
                    null, // ( don't need color for this purpose )
                    lCh.request('activeNoteSubType'),
                    lCh.request('getCurrentDrawingAttributes')
                )['arrow-end'],
                isArrow = arrowAttr !== undefined;

            _.extend( mm, {
                isArrow: isArrow,
                arrowAttr: arrowAttr
            });

            this.currentPathString = this.lineStart
                + (isArrow ? 'L' + (x + ARROW_MIN) + ' ' + (y + ARROW_MIN) : ''); // Raphael line hack (size)

            this.shape = this.paper.path( this.currentPathString );
            this.baseDraw.setShapeAttrs.call(this, this.shape);

            this.$el
                .off( 'mousedown', this.drawStart )
                .on(  'mouseup', this.drawStop )
                .on(  'mousemove', this.drawMove ); //TODO: make fn -- might put this in cb

        },

        // Note: dx, dy, x, y aren't used here -- should clean up
        drawMove: function(e, dx, dy, x, y) {

            if ( !this.baseDraw.move.call(this, e, x, y))
                return;

            var mm = this.mouseModel,
                x = mm.get('xy').x,
                y = mm.get('xy').y,
                p = '';

            if ( !e.shiftKey) {

                p = this.currentPathString = this.lineStart + 'L' + (x > 0 ? x : 0) + ' ' + (y > 0 ? y : 0);

            } else {

                var projection = LockAngleCalcPosition( { x: x, y: y }, mm.get('oxy'), {
                    boundary: this.lockAngleBoundary
                });

                p = this.currentPathString = this.lineStart + 'L' + projection.x + ' ' + projection.y;
            }

            /*
            * Size hack for lines with arrows: get error if path length is too short
            * TODO: this doesn't seem to stop in all cases -- eg
            * - IE SVG4601: SVG Path data has incorrect format and could not be completely parsed.
            * - Chrome <path> attribute d: Expected number, "M461,197CNaN,NaN,NaN,NaN,�".
            * Same issue as was trying to stop in IE below -- unsure, need to research ...
            * */
            if ( mm.isArrow && Raphael.getTotalLength(p) < ARROW_MIN )
                return;


            /*
            * IE hack - TODO: STILL NEEDED???
            * Can still get error: SVG4601: SVG Path data has incorrect format and could not be completely parsed.
            * Same issue as line with too small size ??
            * */
            mm.isArrow
                ? this.shape
                    .attr( 'arrow-end', '' )
                    .attr( 'path', p )
                    .attr( 'arrow-end', mm.arrowAttr )
                : this.shape.attr( 'path', p );

        },
        drawStop: function(e) {

            this.baseDraw.end.call(this, e);
            var mm = this.mouseModel;

            mm.isTooShortOrSmall( this.currentPathString )
                ? this.shape.remove()
                : this.channel.command('addNewlyDrawnShape', this.shape); //Successful: create shape model with the shape and add it to the shape collection

            //Cleanup :
            this.$el.off('mouseup', this.drawStop).off('mousemove', this.drawMove).on('mousedown', this.drawStart); // Note: must come b/f add

            // TODO: this should be helpers
            this.mm = null;
            this.currentPathString = null;
            this.shape = null;
            this.lockAngleBoundary = null;
        }
    };


    this.free = {  //todo: on draw if too short not want wanted -- eg bracket shape
        drawStart: function(e) {

            if (!this.baseDraw.start.apply(this, arguments))
                return;

            var mm = this.mouseModel;
            this.$el.off('mousedown', this.drawStart).on('mouseup', this.drawStop).on('mousemove', this.drawMove);

            this.currentPathString = 'M' +  mm.get('xy').x + ' ' +  mm.get('xy').y; //wants points relative to the previous point, not to the top left of the canvas
            this.shape = this.paper.path(this.currentPathString);
            this.baseDraw.setShapeAttrs.call(this, this.shape);
        },
        drawMove: function(e) {

            if ( !this.baseDraw.move.apply(this, arguments))
                return;

            var mm = this.mouseModel,
                x = mm.get('xy').x,
                y = mm.get('xy').y,
                lx = mm.previous('xy').x,
                ly = mm.previous('xy').y;
            this.currentPathString += 'l' + (x - lx) + ' ' + (y - ly);
            this.shape.attr('path', this.currentPathString);
        },
        drawStop: function(e) {
            this.baseDraw.end.call(this, e);
            this.$el.off('mouseup', this.drawStop).off('mousemove', this.drawMove).on('mousedown', this.drawStart);
            if ( !this.mouseModel.isTooShortOrSmall( this.currentPathString ) ) { //only complete if long enough -- really only dealing with time on this one
                this.channel.command('addNewlyDrawnShape', this.shape );
            } else {
                this.shape.remove();
            }
            //cleanup
            this.mouseModel = null;
            this.currentPathString = null;
            this.shape = null;

        }
    };

    this.text = {
        drawStart: function(e) {

            //exit if already in 'create' mode
            if (this.textAreaView)
                return;

            if (!this.baseDraw.start.apply(this, arguments))
                return;

            var mm = this.mouseModel,
                ch = this.options.channel;

            this.textAreaView = new TextAreaShape({
                x: mm.get('xy').x,
                y:  mm.get('xy').y,
                color: ch.request( 'getColorToApplyToShape', ch.request('activeNote') ),
                canvasView: this,
                paper: this.paper,
                channel: ch,
                onOk: _.bind(function(text) {
                    if (text.length > 0) {
                        this.shape = this.textAreaView.replaceWithTextPath();
                        ch.command('addNewlyDrawnShape', this.shape );
                        ch.command('destroyTextArea'); 
                    } else {
                        ch.command('destroyTextArea', this); //maybe disable in 'dialog' show not possible
                    }
                    ch.command('toggleUserDrawing', false);
                    this.$el.on('mousedown', this.drawStart);

                }, this),
                onCancel: _.bind(function() {
                    ch.command('destroyTextArea', this);
                    ch.command('toggleUserDrawing', false);
                    this.$el.on('mousedown', this.drawStart);
                }, this)

            }).render();

            this.$el.off('mousedown', this.drawStart);
        },
        drawMove: $.noop,
        drawStop: $.noop
    };

    this.hoverShape = {


        // This is really like 'draw end'; occurs after user has placed the temporary 'hover shape'
        // ( CanvasView.enableDrawing sets mousedown handler to drawStart )
        // Note: we don't reach here on edit for signatures, and graphic stamps ( had code to return if not new )
        drawStart: function(e) {

            /* One off for text stamps which may not be ready to be placed yet -- just don't allow */
            if ( this.hoverShape.note.isTextStamp() && !this.hoverShape.note.uiModel.getInputsValid() ) {
                return false;
            }

            this._disableDrawing();

            if (!this.baseDraw.start.apply(this, arguments))
                return;


            this.shape = this.hoverShape.deriveShapeFromClone();

            if ( this.hoverShape.note.isTextStamp() ) {
                this.hoverShape.note.uiModel.setStampPlaced( true );
            }

            this.destroyHoverShape();

            this.baseDraw.end.call( this, e ); //sets is drawing to false

            this.channel.command( 'addNewlyDrawnShape', this.shape ); //adds shape to collection

            // Temp for this: don't want to allow to place others
            this.$el.addClass('default-cursor');


        },
        drawMove: $.noop,
        drawStop: $.noop,

        /**
         * TODO:
         * - This really should be done by having 'subShapes' and getting the draw functions from them, not the prototype ...
         * - ( this would be more flexible and get rid of the 'ifs' ... )
         */
        createHoverShape: function( note ) {

            var hoverShape = this.hoverShape =
                HoverShapeFactory( note, this.paper, this.channel ).render();

            // --- put all off this into factor ... ---

            /**
             * Note: need mouseenter and mouseleave (vs. mouseover, mouseout) so events don't bubble from descendants (eg: shapes)
             * Utilizing jQuery hover events, not Raphael for the paper (would need an element of it's size).
             * Move shape with cursor at the top-right of the mouse position until draw start.
             */
            this.$el
                .on('mousemove', _.bind(function (e) {

                    // TODO: now same as e.offsetX, e.offsetY ( change it and test )
                    var mousePos = this.getMousePos(e),
                        x = mousePos.x,
                        y = mousePos.y;

                    // No longer using -- perhaps could utilize something like this to persist
                    // position between canvas re-renders
                    // this.lastMousePosition = mousePos;

                    hoverShape.trigger( 'hoverShape:mouseMove', x, y );

                }, this))

            /**
             * Must defer in case mouse moves too fast --
             * DVBC-310: is this not getting caught still an issue ?
             */
                .on('mouseenter', function() {
                    _.defer( function() {
                        hoverShape.trigger('hoverShape:mouseEnterCanvas');
                    });
                })
                .on('mouseleave', function() {
                    _.defer( function() {
                        hoverShape.trigger('hoverShape:mouseExitCanvas');
                    });
                });

        },
        destroyHoverShape: function() {

            this.hoverShape.destroy();
            delete this.hoverShape; //( also serves as a flag that we're not already creating )
            this.$el.off('mousemove mouseenter mouseleave');

        }
    };


    init.call(this);


};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/canvasDrawFunctions.js
 ** module id = 362
 ** module chunks = 0
 **/